module.exports = __webpack_public_path__ + "img/hello_card_details.eb97343e.svg";